<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Service Providers</h3>
        <div class="text-xs-right">
          <!--          <v-btn-->
          <!--              @click="showAddDialog"-->
          <!--              color="blue darken-3"-->
          <!--              dark-->
          <!--              fab-->
          <!--              v-if="$oauth.checkIfHasPermission(['alter service-provider'])"-->
          <!--              x-small>-->
          <!--            <v-icon>add</v-icon>-->
          <!--          </v-btn>-->
          <export-button
              class="ml-2"
              v-if="$oauth.checkIfHasPermission(['export service-provider'])"/>
          <refresh-button :click-function="getAll"></refresh-button>
        </div>
      </v-flex>
      <v-row>
        <v-col cols="12" md="4">
          <v-card outlined class="stats-card" style="border-color: #1976D2 !important; border-width: 1px;">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="blue lighten-5" size="56" class="mr-4">
                  <v-icon color="blue darken-2" size="32">mdi-office-building</v-icon>
                </v-avatar>

                <div class="flex-grow-1 ml-4">
                  <div class="text-overline grey--text text--darken-1 mb-1">
                    Trekking Agencies
                  </div>
                  <div class="text-h4 font-weight-bold primary--text">
                    {{ grandTotalAgencies || 0 }}
                  </div>
                  <div class="text-caption grey--text">
                    Total registered agencies
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="stats-card"  style="border-color: #388E3C !important; border-width: 1px;">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="green lighten-5" size="56" class="mr-4">
                  <v-icon color="green darken-2" size="32">mdi-home-city</v-icon>
                </v-avatar>

                <div class="flex-grow-1 ml-4">
                  <div class="text-overline grey--text text--darken-1 mb-1">
                    Hotels
                  </div>
                  <div class="text-h4 font-weight-bold success--text">
                    {{ grandTotalServiceProviders || 0 }}
                  </div>
                  <div class="text-caption grey--text">
                    Total registered hotels
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="stats-card"  style="border-color: #F57C00 !important; border-width: 1px;">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="orange lighten-5" size="56" class="mr-4">
                  <v-icon color="orange darken-2" size="32">mdi-account-group</v-icon>
                </v-avatar>

                <div class="flex-grow-1 ml-4">
                  <div class="text-overline grey--text text--darken-1 mb-1">
                    Service Providers
                  </div>
                  <div class="text-h4 font-weight-bold orange--text text--darken-2">
                    {{ totalProviderCount || 0 }}
                  </div>
                  <div class="text-caption grey--text">
                    Total service providers
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="pb-0" xs4>
              <v-text-field
                  :elevation="0"
                  class="hidden-sm-and-down "
                  flat
                  hide-details
                  placeholder="Search by typing here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="handleFilterChange"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 class="pb-0">
            <v-select
                :items="status"
                item-value="id"
                item-text="name"
                flat
                hide-details
                label="Filter By Status"
                @change="handleFilterChange"
                prepend-inner-icon="filter_list"
                solo
                clearable
                v-model="filters.status"
            />
          </v-flex>

          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="serviceProviders"
                :loading="loading"
                :options.sync="pagination"
                :server-items-length="totalNumber"
                item-key="id">
              <template v-slot:item.display_image="{ item }">
                <file-display
                    :src="item.display_image">
                </file-display>
              </template>
              <template v-slot:item.status="{ item }">
                <table-status :status="item.status"></table-status>
              </template>
              <template v-slot:item.lat="{ item }">
                {{ item.lat || '-' }}
              </template>
              <template v-slot:item.long="{ item }">
                {{ item.long || '-' }}
              </template>
              <template v-slot:item.remarks="{ item }">
                {{ item.remarks || '-' }}
              </template>
              <template v-slot:item.approved_rejected_by="{ item }">
                {{ item.approved_rejected_by ? item.approved_rejected_by.full_name : 'N/A' }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="view(item)"
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small>
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="$oauth.checkIfHasPermission(['alter service-provider'])"
                        @click="edit(item)"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="$oauth.checkIfHasPermission(['delete service-provider'])"
                        @click="confirmDelete(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-if="$oauth.checkIfHasPermission(['alter service-provider'])"
        v-model="form"
        width="700">

      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>{{ formData.id ? 'Edit' : 'New' }} Service Provider</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <form-error-display-handler :errors="errors"></form-error-display-handler>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef" v-model="valid">
                  <v-layout row wrap>
                    <v-flex md6 xs6>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Name of the Service Provider *"
                          outlined
                          type="text"
                          v-model="formData.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs6>
                      <v-autocomplete
                          :items="service_provider_types"
                          :rules="[rules.required]"
                          class="mr-1"
                          item-text="name"
                          item-value="id"
                          label="Select Service Provider Type *"
                          outlined
                          @change="getPurposes"
                          v-model="formData.type"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md12 xs12>
                      <v-autocomplete
                          :items="service_provider_purposes"
                          :rules="[rules.required]"
                          class="mr-1"
                          item-text="purpose"
                          item-value="id"
                          label="Select Service Provider Purpose *"
                          outlined
                          multiple
                          v-model="formData.purpose"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md4 xs4>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Address *"
                          outlined
                          type="text"
                          v-model="formData.address"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 xs4>
                      <v-text-field
                          label="Latitude"
                          outlined
                          type="text"
                          v-model="formData.lat"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 xs4>
                      <v-text-field
                          label="Longitude"
                          outlined
                          type="text"
                          v-model="formData.long"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <file-input :image-url="formData.display_image"
                                  :required="!formData.id"
                                  label="Logo *"
                                  v-model="formData.image"
                                  :file-size="2048"></file-input>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-4"></v-divider>
                  <h3 class="mt-4">User Information</h3>
                  <v-layout row wrap class="mt-4" v-if="formData && formData.userInformation">
                    <v-flex md6 xs6>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Name"
                          outlined
                          type="text"
                          v-model="formData.userInformation.name"
                          readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs6>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Position"
                          outlined
                          type="text"
                          v-model="formData.userInformation.position"
                          readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                          :rules="[rules.required,rules.number,rules.mobileLength]"
                          label="Mobile Number"
                          outlined
                          v-model="formData.userInformation.mobile_number"
                          readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                          :rules="[rules.required,rules.email]"
                          label="Email"
                          outlined
                          v-model="formData.userInformation.email"
                          readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="form = false; formData={};"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="saveModel"
              class="white--text"
              color="blue darken-3"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import FileInput from "../components/FileInput";
import {commonListMixin} from "../mixins/commonListMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {validationMixin} from "../mixins/validationMixin";
import RefreshButton from "@/components/RefreshButton";
import {fetchDynamicValues} from "../helpers/dynamicValueHelper";
import {buildFormData} from "../helpers/FormedData";
import FileDisplay from "../components/FileDisplay";
import {mapActions, mapGetters} from "vuex";
import TableStatus from "@/components/TableStatus";

export default {
  name: "ServiceProvider",
  components: {FileDisplay, RefreshButton, FormErrorDisplayHandler, FileInput, TableStatus},
  data() {
    return {
      model: "service-provider",
      types: [],
      status: [
        {
          id: -1,
          name: 'All'
        },
        {
          id: 0,
          name: 'Applied/Pending'
        },
        {
          id: 1,
          name: 'Approved'
        },
        {
          id: 3,
          name: 'Rejected'
        },
      ],
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Logo",
          value: "display_image",
          sortable: false
        },
        {
          text: 'Type',
          value: 'type_name'
        },
        {
          text: 'Latitude',
          value: 'lat'
        },
        {
          text: 'Longitude',
          value: 'long'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: "Remarks",
          value: "remarks",
          sortable: false,
        },

        {
          text: "Approved / Rejected By",
          value: "approved_rejected_by",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false
        }
      ],
    };
  },

  mixins: [commonListMixin, validationMixin],

  computed: {
    ...mapActions('ServiceProvider', ['getAllServiceProviderTypes']),
    ...mapGetters({
      service_provider_types: 'ServiceProvider/serviceProviderTypes',
      service_provider_purposes: 'ServiceProvider/serviceProviderTypePurposes',
      trekkingAgencyCount: 'ServiceProvider/trekkingAgencyCount',
      serviceProviderCount: 'ServiceProvider/serviceProviderCount',
      totalCount: 'ServiceProvider/totalCount'
    }),
    serviceProviders() {
      return this.$store.state.CommonList.all;
    },
    // Add computed properties for the cards
    grandTotalAgencies() {
      return this.trekkingAgencyCount || 0;
    },
    grandTotalServiceProviders() {
      return this.serviceProviderCount || 0;
    },
    totalProviderCount() {
      return this.totalCount;
    }
  },
  methods: {
    view(item) {
      this.$router.push({
        name: "ViewServiceProvider",
        params: {
          id: item.id
        }
      });
    },
    saveModel() {
      if (this.$refs.formRef.validate()) {
        let formData = new FormData();
        buildFormData(formData, this.formData);
        this.modelData = formData;
        this.save('Service Provider');
      }
    },
    edit(item) {
      this.formData = JSON.parse(JSON.stringify(item));
      if (this.formData.type) {
        this.$store.dispatch("ServiceProvider/getAllServiceProviderTypePurpose", this.formData.type)
      }
      this.form = true;
    },
    async confirmDelete(item) {
      await this.destroy(item, 'Service Provider deleted successfully');
    },
    getPurposes() {
      this.$store.dispatch("ServiceProvider/getAllServiceProviderTypePurpose", this.formData.type)
    },
    showAddDialog() {

      if (this.$refs.formRef)
        this.$refs.formRef.reset();
      this.editing = false;

      this.errors = null;
      this.formData = {userInformation: {name: null, mobile_number: null, position: null, email: null}};
      this.form = true;
    },
    async fetchCounts() {
      try {
        await this.$store.dispatch("ServiceProvider/getAllTrekkingAndProvidersCount");
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    },
  },
  mounted() {
    this.$store.commit("CommonList/setModel", this.model);
    if (this.$store.state.ServiceProvider.service_provider_types.length == 0) {
      this.$store.dispatch("ServiceProvider/getAllServiceProviderTypes");
    }
    this.fetchCounts();
    // this.getAll();
  }
}
</script>

<style scoped>

</style>
